import { Component } from 'react';

class ErrorBoundary extends Component {
  constructor() {
    super();
    this.state = { hasErrors: false };
  }

  componentDidCatch(error) {
    console.log(error);
    this.setState({ hasErrors: true });
  }

  render() {
    if (this.state.hasErrors) {
      return (
        <div style={{ backgroundColor: 'white', height: '90vh', fontSize: '25px' }}>
          Something went wrong!
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
